import React, { Component } from 'react';
import 'antd/dist/antd.css';
import './index.css';
import { Layout, Menu,} from 'antd';
import {
  
  DollarCircleOutlined,
  CustomerServiceOutlined,
  PieChartOutlined,
  UsergroupAddOutlined,
  UserOutlined,

  NotificationOutlined,
  SettingOutlined,
  QrcodeOutlined,
  FileTextOutlined,
  ShoppingCartOutlined,
  MobileOutlined,
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
const { Sider } = Layout;
const { SubMenu } = Menu;

class Sidebar extends Component {
  state = {
    collapsed: false,
    access: null
  };
componentDidMount = () => {
  this.setState({access: JSON.parse(localStorage.getItem('access'))})
}
  onCollapse = collapsed => {
    this.setState({ collapsed });
  };

  render() {
    const { collapsed,access } = this.state;
    return (
        <Sider collapsible collapsed={collapsed} onCollapse={this.onCollapse} width="280px"
        breakpoint="sm"
      collapsedWidth="80"
        style={{backgroundColor: 'white', boxShadow:"4px 3px 8px 0px rgba(0,0,0,0.10)" }}>
        
          <Menu theme="light" defaultSelectedKeys={['1']} mode="inline">
            <Menu.Item key="1" icon={<PieChartOutlined />}>
            <Link to="/dashboard">Dashboard</Link>
            </Menu.Item>

            {access?.user_management ?
            <SubMenu key="user-management" icon={<UserOutlined />} title="Admin Management">
              <Menu.Item key="role"><Link to="/roles">Role</Link></Menu.Item>
              <Menu.Item key="3"><Link to="/users">User</Link></Menu.Item>
            </SubMenu>
            :null}

            {access?.client_management ?
            <SubMenu key="client-management" icon={<UsergroupAddOutlined />} title="Client Management">
              <Menu.Item key="clients"><Link to="/clients">Clients</Link></Menu.Item>
              
            </SubMenu>
            :null}
            {access?.app_management ?
            <SubMenu key="app-management" icon={<MobileOutlined />} title="App Management">
              <Menu.Item key="appUser"><Link to="/appUsers">Users</Link></Menu.Item>
            </SubMenu>
            :null}

            {access?.code_management ?
            <SubMenu key="code-management" icon={<QrcodeOutlined />} title="Code Management">
              <Menu.Item key="batch"><Link to="/batch">Batch</Link></Menu.Item>
              <Menu.Item key="code"><Link to="/code">Code</Link></Menu.Item>
            
            </SubMenu>
            :null}
            
            {access?.finance_management ?
            <SubMenu key="finance-management" icon={<DollarCircleOutlined />} title="Finance Management">
              <Menu.Item key="finance/orders"><Link to="/finance/orders">Batch</Link></Menu.Item>
            </SubMenu>
            :null}

            {access?.report_management ?
              <SubMenu key="report-management" icon={<FileTextOutlined />} title="Report Management">
                <Menu.Item key="report"><Link to="/reports">Reports</Link></Menu.Item>
              </SubMenu>
            :null}
            {access?.product_management ?
              <SubMenu key="product-management" icon={<ShoppingCartOutlined /> } title="Product Management">
                <Menu.Item key="product"><Link to="/products">Product</Link></Menu.Item>
              </SubMenu>
            :null}
            
            {access?.message_management ?
            <></>
            :null}

            {access?.support_management ?
            <>
            <SubMenu key="support" icon={<CustomerServiceOutlined />} title="Support Management">
              <Menu.Item key="/support/tickets"><Link to="/support/tickets">Tickets</Link></Menu.Item>
            </SubMenu>
            
            <SubMenu key="contact" icon={<NotificationOutlined />} title="Response Management">
              <Menu.Item key="/contact/responses"><Link to="/contact/responses">Responses</Link></Menu.Item>
            </SubMenu>
            </>
            :null}

            {access?.setting_management ?
            <SubMenu key="setting" icon={<SettingOutlined />} title="Setting">
              <Menu.Item key="/setting/api"><Link to="/setting/api">Api List</Link></Menu.Item>
            </SubMenu>
           : null}
          </Menu>
        </Sider>
    );
  }
}

 
export default Sidebar;